import { render } from "./PageHeader.vue?vue&type=template&id=c8071cd8&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=c8071cd8&lang=less&scoped=true"
import "./PageHeader.vue?vue&type=style&index=1&id=c8071cd8&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/线上短信平台/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8071cd8"]])

export default __exports__